import { LitElement, html, css } from 'lit';
import { designSystem, componentStyles } from '../../styles/design-system.js';
import { settingsStyles } from '../../styles/settings-styles.js';
import { iconStyles } from '../../styles/icon-styles.js';
import { settingsService } from '../../services/settings-service.js';

export class RoutingSettings extends LitElement {
  static properties = {
    _routes: { state: true },
    _loaded: { state: true }
  };

  static styles = [designSystem, componentStyles, settingsStyles, css`
    .manage-link {
      display: inline-flex;
      align-items: center;
      gap: var(--space-2);
      margin-top: var(--space-4);
      font-family: var(--font-body);
      font-size: var(--text-sm);
      color: var(--color-primary);
      text-decoration: none;
      cursor: pointer;
      transition: color var(--transition-fast);
    }
    .manage-link:hover { color: var(--color-accent); }
  `];

  constructor() {
    super();
    this._routes = [];
    this._loaded = false;
  }

  connectedCallback() {
    super.connectedCallback();
    this._load();
  }

  async _load() {
    try {
      const data = await settingsService.loadPhoneRouting();
      if (data.success) {
        this._routes = data.routes || [];
        this._loaded = true;
      }
    } catch (err) {
      console.error('[RoutingSettings] Load failed:', err);
    }
  }

  render() {
    return html`
      ${iconStyles}
      <div class="content-header">
        <h2 class="content-title">Phone Routing</h2>
        <p class="content-description">Active phone routes show how calls are directed to AI agents. Manage routes from the Phone Numbers page.</p>
      </div>

      <div class="settings-section">
        <div class="section-title-row">
          <i class="fa-sharp-duotone fa-solid fa-phone-arrow-right section-icon"></i>
          <span class="section-title">Active Routes</span>
        </div>

        ${this._routes.length === 0 && this._loaded ? html`
          <div class="empty-state">
            <i class="fa-sharp fa-light fa-phone-slash"></i>
            <p>No active phone routes configured.</p>
            <p style="font-size:var(--text-xs);">Import phone numbers and assign agents from the Phone Numbers page.</p>
          </div>
        ` : ''}

        ${this._routes.length > 0 ? html`
          <div class="table-wrap">
            <table class="data-table">
              <thead>
                <tr>
                  <th>Phone Number</th>
                  <th>Park Name</th>
                  <th>Agent Personality</th>
                  <th>Timezone</th>
                </tr>
              </thead>
              <tbody>
                ${this._routes.map(route => html`
                  <tr>
                    <td style="font-family:var(--font-mono);color:var(--color-text-primary);">${route.number || '—'}</td>
                    <td style="font-weight:var(--font-medium);color:var(--color-text-primary);">${route.park_name || '—'}</td>
                    <td>${route.personality || '—'}</td>
                    <td>${route.timezone || '—'}</td>
                  </tr>
                `)}
              </tbody>
            </table>
          </div>
        ` : ''}

        <a class="manage-link" href="#" @click=${this._goToPhoneNumbers}>
          <i class="fa-sharp fa-light fa-arrow-right"></i>
          Manage routes from Phone Numbers
        </a>
      </div>
    `;
  }

  _goToPhoneNumbers(e) {
    e.preventDefault();
    this.dispatchEvent(new CustomEvent('navigate', { detail: { page: 'phone-numbers' }, bubbles: true, composed: true }));
  }
}

customElements.define('routing-settings', RoutingSettings);
